import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import "flatpickr/dist/plugins/monthSelect/style.css";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import Select from "react-select";

export default function ServiceTaskReport() {
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [clients, setClients] = useState([]);
  const [categories, setCategories] = useState([]);
  const userId = localStorage.getItem("userId");
  const [filterValues, setFilterValues] = useState({
    staffId: "00000000-0000-0000-0000-000000000000",
    clientId: "00000000-0000-0000-0000-000000000000",
    categoryId: "00000000-0000-0000-0000-000000000000",
    fromDate: new Date(),
    toDate: new Date(),
    status: "",
  });

  const headerconfig = {
    headers: { Authorization: "Bearer " + localStorage.getItem("userToken") },
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterValues({
      ...filterValues,
      [name]: value,
    });
  };

  const handleSearch = () => {
    GetData();
  };
  const handleClear = () => {
    GetData();
    setFilterValues({
      staffId: "00000000-0000-0000-0000-000000000000",
      clientId: "00000000-0000-0000-0000-000000000000",
      categoryId: "00000000-0000-0000-0000-000000000000",
      fromDate: new Date(),
      toDate: new Date(),
      status: "",
    });
  };

  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.SERVICETASKREPORT +
          "?userId=" +
          userId +
          "&staffId=" +
          filterValues.staffId +
          "&clientId=" +
          filterValues.clientId +
          "&categoryId=" +
          filterValues.categoryId +
          "&fromDate=" +
          moment(filterValues.fromDate).format("YYYY-MM-DD") +
          "&toDate=" +
          moment(filterValues.toDate).format("YYYY-MM-DD") +
          "&status=" +
          filterValues.status +
          "",
        { ...headerconfig }
      )
      .then((response) => {
        setLists(response.data.data);
        setData(response.data.data);
      });
  };

  const GetStaffs = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETALLSTAFFS + "?userId=" + userId, {
        ...headerconfig,
      })
      .then((response) => {
        setStaffs(response.data.data);
      });
  };

  const GetClients = () => {
    axios
      .get(
        config.APIACTIVATEURL + config.GETALLCLIENTS + "?userId=" + userId,
        headerconfig
      )
      .then((response) => {
        setClients(response.data.data);
      });
  };

  const GetCategories = () => {
    axios
      .get(
        config.APIACTIVATEURL + config.GETBOTTOMLEVELCATEGORIES,
        headerconfig
      )
      .then((response) => {
        setCategories(response.data.data);
      });
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  useEffect(() => {
    GetData();
    GetStaffs();
    GetClients();
    GetCategories();
  }, []);

  const handleExport = (type) => {
    if (lists.length === 0) {
      handleError("No data to export");
      return;
    }

    switch (type) {
      case "pdf":
        exportToPDF();
        break;
      case "excel":
        exportToExcel();
        break;
      case "print":
        window.print();
        break;
      default:
        break;
    }
  };

  const exportToPDF = () => {
    const doc = new jsPDF();

    // Add title
    doc.setFontSize(16);
    doc.text("Service Task Report", 14, 15);
    doc.setFontSize(10);
    doc.text("Generated on: " + moment().format("DD-MMM-YYYY hh:mm A"), 14, 22);

    // Add filter criteria
    let yPosition = 30;
    doc.text("Filter Criteria:", 14, yPosition);
    yPosition += 7;

    if (filterValues.staffId !== "00000000-0000-0000-0000-000000000000") {
      const staffName = staffs.find(
        (s) => s.staffId === filterValues.staffId
      )?.staffName;
      doc.text("Staff: " + staffName, 14, yPosition);
      yPosition += 7;
    }

    if (filterValues.clientId !== "00000000-0000-0000-0000-000000000000") {
      const clientName = clients.find(
        (c) => c.clientId === filterValues.clientId
      )?.clientName;
      doc.text("Client: " + clientName, 14, yPosition);
      yPosition += 7;
    }

    if (filterValues.categoryId !== "00000000-0000-0000-0000-000000000000") {
      const categoryName = categories.find(
        (c) => c.categoryId === filterValues.categoryId
      )?.categoryName;
      doc.text("Category: " + categoryName, 14, yPosition);
      yPosition += 7;
    }

    if (filterValues.status) {
      doc.text("Status: " + filterValues.status, 14, yPosition);
      yPosition += 7;
    }

    doc.text(
      "Date Range: " +
        moment(filterValues.fromDate).format("DD-MMM-YYYY") +
        " to " +
        moment(filterValues.toDate).format("DD-MMM-YYYY"),
      14,
      yPosition
    );
    yPosition += 10;

    // Prepare data for PDF
    const headers = [
      "Staff",
      "Client",
      "Category",
      "Service",
      "Month",
      "Cycle",
      "Status",
      "Amount",
      "Payment Status",
      "Last Updated",
    ];

    const data = lists.map((task) => [
      task.staffName,
      task.clientName,
      task.categoryName,
      task.serviceName,
      moment(task.month).format("MMM-YYYY"),
      task.cycle,
      task.status,
      task.amount?.toFixed(2),
      task.paymentStatus,
      moment(task.lastUpdatedDate).format("DD-MMM-YYYY hh:mm A"),
    ]);

    // Add table to PDF
    autoTable(doc, {
      head: [headers],
      body: data,
      startY: yPosition,
      styles: {
        fontSize: 8,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontSize: 9,
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240],
      },
      margin: { top: yPosition },
    });

    doc.save(
      "ServiceTaskReport_" + moment().format("YYYYMMDD_HHmmss") + ".pdf"
    );
  };

  const exportToExcel = () => {
    const data = lists.map((task) => ({
      Staff: task.staffName,
      Client: task.clientName,
      Category: task.categoryName,
      Service: task.serviceName,
      Month: moment(task.month).format("MMM-YYYY"),
      Cycle: task.cycle,
      Status: task.status,
      Amount: task.amount?.toFixed(2),
      "Payment Status": task.paymentStatus,
      "Last Updated": moment(task.lastUpdatedDate).format(
        "DD-MMM-YYYY hh:mm A"
      ),
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "ServiceTasks");

    // Add header information
    const headerInfo = [
      ["Service Task Report"],
      ["Generated on: " + moment().format("DD-MMM-YYYY hh:mm A")],
      [],
      ["Filter Criteria:"],
    ];

    if (filterValues.staffId !== "00000000-0000-0000-0000-000000000000") {
      const staffName = staffs.find(
        (s) => s.staffId === filterValues.staffId
      )?.staffName;
      headerInfo.push(["Staff: " + staffName]);
    }

    if (filterValues.clientId !== "00000000-0000-0000-0000-000000000000") {
      const clientName = clients.find(
        (c) => c.clientId === filterValues.clientId
      )?.clientName;
      headerInfo.push(["Client: " + clientName]);
    }

    if (filterValues.categoryId !== "00000000-0000-0000-0000-000000000000") {
      const categoryName = categories.find(
        (c) => c.categoryId === filterValues.categoryId
      )?.categoryName;
      headerInfo.push(["Category: " + categoryName]);
    }

    if (filterValues.status) {
      headerInfo.push(["Status: " + filterValues.status]);
    }

    headerInfo.push([
      "Date Range: " +
        moment(filterValues.fromDate).format("DD-MMM-YYYY") +
        " to " +
        moment(filterValues.toDate).format("DD-MMM-YYYY"),
    ]);
    headerInfo.push([""]);

    XLSX.utils.sheet_add_aoa(ws, headerInfo, { origin: -1 });

    // Adjust column widths
    const wscols = [
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 25 },
      { wch: 12 },
      { wch: 10 },
      { wch: 12 },
      { wch: 12 },
      { wch: 15 },
      { wch: 20 },
    ];
    ws["!cols"] = wscols;

    XLSX.writeFile(
      wb,
      "ServiceTaskReport_" + moment().format("YYYYMMDD_HHmmss") + ".xlsx"
    );
  };

  return (
    <div id="layout-wrapper">
      <LayoutHeader />
      <LayoutSideBar />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-0">Service Task Report</h4>
                </div>
              </div>
            </div>
            <div className="alert alert-success">
              <form autoComplete="off">
                <div className="row">
                  <div className="col-lg-2">
                    <label>Staff</label>
                    <select
                      name="staffId"
                      value={filterValues.staffId}
                      onChange={handleFilterChange}
                      className="form-select"
                    >
                      <option value="00000000-0000-0000-0000-000000000000">
                        All
                      </option>
                      {staffs.map((s) => (
                        <option key={s.staffId} value={s.staffId}>
                          {s.staffName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-2">
                    <label>Client</label>
                    <Select
                      name="clientId"
                      value={
                        clients.find(
                          (c) => c.clientId === filterValues.clientId
                        )
                          ? {
                              value: filterValues.clientId,
                              label:
                                clients.find(
                                  (c) => c.clientId === filterValues.clientId
                                )?.clientName || "All",
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        setFilterValues({
                          ...filterValues,
                          clientId: selectedOption
                            ? selectedOption.value
                            : "00000000-0000-0000-0000-000000000000",
                        })
                      }
                      options={[
                        {
                          value: "00000000-0000-0000-0000-000000000000",
                          label: "All",
                        },
                        ...clients.map((c) => ({
                          value: c.clientId,
                          label: c.clientName,
                        })),
                      ]}
                      isSearchable
                      placeholder="Select Client"
                    />
                  </div>
                  <div className="col-lg-2">
                    <label htmlFor="categoryId" className="form-label">
                      Category
                    </label>
                    <select
                      name="categoryId"
                      value={filterValues.categoryId}
                      onChange={handleFilterChange}
                      className={"form-select " + applyErrorClass("categoryId")}
                    >
                      <option value="00000000-0000-0000-0000-000000000000">
                        All
                      </option>
                      {categories.map((c) => (
                        <option key={c.categoryId} value={c.categoryId}>
                          {c.categoryName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-2">
                    <div className="mb-3">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <select
                        name="status"
                        value={filterValues.status}
                        onChange={handleFilterChange}
                        className="form-select"
                      >
                        <option value="">All</option>
                        <option value="COMPLETED">COMPLETED</option>
                        <option value="PENDING">PENDING</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <label>From Date</label>
                    <div className="input-group">
                      <Flatpickr
                        value={filterValues.fromDate}
                        onChange={(dates) => {
                          setFilterValues((prev) => ({
                            ...prev,
                            fromDate: dates[0],
                          }));
                        }}
                        options={{
                          dateFormat: "d-M-Y",
                        }}
                        className={"form-control" + applyErrorClass("fromDate")}
                        placeholder="Select From Date"
                      />
                      <div className="input-group-text bg-primary border-primary text-white">
                        <i className="ri-calendar-2-line" />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <label>To Date</label>
                    <div className="input-group">
                      <Flatpickr
                        value={filterValues.toDate}
                        onChange={(dates) => {
                          setFilterValues((prev) => ({
                            ...prev,
                            toDate: dates[0],
                          }));
                        }}
                        options={{
                          dateFormat: "d-M-Y",
                          minDate: filterValues.fromDate,
                        }}
                        className={"form-control" + applyErrorClass("toDate")}
                        placeholder="Select To Date"
                      />
                      <div className="input-group-text bg-primary border-primary text-white">
                        <i className="ri-calendar-2-line" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="hstack gap-2 justify-content-end mb-3 mt-3">
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={isLoading}
                    onClick={handleSearch}
                  >
                    {isLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-1"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Searching...
                      </>
                    ) : (
                      <>
                        <i className="ri-search-line me-1"></i> Search
                      </>
                    )}
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleClear}
                    disabled={isLoading}
                  >
                    <i className="ri-refresh-line me-1"></i> Clear
                  </button>

                  <div className="btn-group">
                    <button
                      type="button"
                      className="btn btn-success dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      disabled={lists.length === 0 || isLoading}
                    >
                      <i className="ri-download-line me-1"></i> Export
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => handleExport("pdf")}
                        >
                          <i className="ri-file-pdf-line me-2"></i> PDF
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => handleExport("excel")}
                        >
                          <i className="ri-file-excel-line me-2"></i> Excel
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => handleExport("print")}
                        >
                          <i className="ri-printer-line me-2"></i> Print
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </form>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    {isLoading ? (
                      <div className="text-center py-4">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                        <p className="mt-2">Loading data...</p>
                      </div>
                    ) : (
                      <div className="table-responsive table-card">
                        <table
                          className="table table-centered align-middle"
                          id="serviceTaskTable"
                        >
                          <thead className="table-light">
                            <tr>
                              <th>Staff</th>
                              <th>Client</th>
                              <th>Category</th>
                              <th>Service</th>
                              <th>Month</th>
                              <th>Cycle</th>
                              <th>Status</th>
                              <th>Amount</th>
                              <th>Payment Status</th>
                              <th>Created Date</th>
                              <th>Last Updated</th>
                            </tr>
                          </thead>
                          <tbody>
                            {lists.length > 0 ? (
                              lists.map((task) => (
                                <tr key={task.serviceTaskId}>
                                  <td>{task.staffName || "Unassigned"}</td>
                                  <td>{task.clientName}</td>
                                  <td>{task.categoryName}</td>
                                  <td>{task.serviceName}</td>
                                  <td>
                                    {moment(task.month).format("MMM-YYYY")}
                                  </td>
                                  <td>{task.cycle}</td>
                                  <td>
                                    <span
                                      className={
                                        "badge bg-" +
                                        (task.status === "COMPLETED"
                                          ? "success"
                                          : "warning")
                                      }
                                    >
                                      {task.status}
                                    </span>
                                  </td>
                                  <td>{task.amount?.toFixed(2)}</td>
                                  <td>
                                    <span
                                      className={
                                        "badge bg-" +
                                        (task.paymentStatus === "SUCCESS"
                                          ? "success"
                                          : "warning")
                                      }
                                    >
                                      {task.paymentStatus}
                                    </span>
                                  </td>
                                  <td>
                                    {moment(task.createdDate).format(
                                      "DD-MMM-YYYY hh:mm A"
                                    )}
                                  </td>
                                  <td>
                                    {moment(task.lastUpdatedDate).format(
                                      "DD-MMM-YYYY hh:mm A"
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="10" className="text-center py-4">
                                  {!isLoading && "No data available"}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
